<template>
  <ContratoPendente
    :navigation-mode="navigationMode"
    :vue-base-url="vueBaseUrl"
    :auto-fetch="autoFetch"
  />
</template>

<script setup lang="ts">
import ContratoPendente from "@/ui/components/Layout/Navbar/MenuDeAcoes/ContratoPendente/ContratoPendente.vue";

withDefaults(
  defineProps<{
    navigationMode?: "vue" | "mvc";
    vueBaseUrl?: string;
    autoFetch?: boolean;
  }>(),
  {
    navigationMode: "vue",
    vueBaseUrl: "/v2/#",
    autoFetch: true
  }
);
</script>
